import emailjs from "@emailjs/browser";

//Function to send me an email, using the form
function SendEmail(name: string, email: string, phoneNmb: string, title: string, message: string): string | void | Promise<string> {
  // Check if env var is defined, although process.env is usually string | undefined
  if (!process.env.REACT_APP_EMAILJS_PUBLIC_KEY) {
      console.error("REACT_APP_EMAILJS_PUBLIC_KEY is not defined");
      return "Email service not configured";
  }
  
  emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  
  //Validating any inputs
  if (name === "" || email === "" || phoneNmb === "" || title === "" || message === "") {
    return "One or more email inputs are empty..."
  }

  //Sending the email
  return emailjs
    .send("service_96rkkea", "template_lnylt2x", {
      from_name: name,
      email: email,
      phoneNmb: phoneNmb,
      title: title,
      message: message,
    })
    .then(
      (response) => {
        //Noting success
        return "Email Successfully Sent"
      },
      (error) => {
        return "An error has occurred when sending the email"
      }
    );
}

export default SendEmail;
